import hyperdom from 'hyperdom'
import {isString} from 'lodash-es'
import formatPrice from 'root-packages/price-engine/formatPrice.js'
import TripSummary from '../../../defaultFlow/tabs/confirmation/tripSummary.jsx'

export default class TripSummaryDayTour extends TripSummary {

  constructor (options) {
    super(options)
  }

  render () {
    const details = this.getTripDetails()
    return details ? <div class="trip-summary">
      <div class="trip-summary__header">Trip summary</div>
      <div>
        {this.renderTripDates()}
      </div>
      <hr></hr>
      {this.renderPriceBreakdown(details)}
    </div> : undefined
  }

  renderTripDatesRegularLayout () {
    return <div class="trip-summary__container">
      <div class="trip-summary__icon -new-ui_calendar"></div>
      <div class="trip-summary__trip-dates-container">
        <div class="trip-summary__title-container">Trip Dates</div>
        <div class="trip-summary__trip-dates-details">
          <div class="trip-summary__trip-start-date">{this.renderTripDate({isStartDate: true})}</div>
          <div class="trip-summary__trip-end-date">{this.renderTripDate({isStartDate: false})}</div>
          <div class="trip-summary__trip-dates__direction-icon -new-ui_long-arrow-right"></div>
        </div>
      </div>
    </div>
  }

  renderTripDatesSmallLayout () {
    return <div class="trip-summary__container">
      <div class="trip-summary__trip-dates-header">
        <div class="trip-summary__icon-small -new-ui_calendar"></div>
        <div class="trip-summary__title-container">Trip Dates</div>
      </div>
      <div class="trip-summary__trip-dates-details">
        <div class="u-margin-bottom-small trip-summary__trip-start-date">{this.renderTripDate({isStartDate: true})}</div>
        <div class="u-margin-bottom-small trip-summary__trip-end-date">{this.renderTripDate({isStartDate: false})}</div>
      </div>
    </div>
  }

  renderPriceBreakdown ({prices, currency, payment: {amount}}) {

    return <div class="trip-summary-price-breakdown">
      <div class="trip-summary-price-breakdown__container">
        <h4 class="trip-summary-price-breakdown__title">Price breakdown</h4>
        <div class="trip-summary-price-breakdown__price-container">
          {
            prices.filter(({price}) => !this.config.hideZeroValueMiscProductsInSummary || !!price).map(({
              name,
              isDiscount,
              price,
            }) => {
              return <div class="trip-summary-price-breakdown__price-container-row">
                <div
                  class="trip-summary-price-breakdown__price-name">{name === 'Frequent Traveller Discount' ? this.config.localisedWords.ftd : name}</div>
                <div class={{
                  'trip-summary-price-breakdown__discount-price': isDiscount,
                  'trip-summary-price-breakdown__price-amount': !isDiscount,
                }}>
                  {isDiscount ? '- ' : ''}
                  {isString(price) ? price : formatPrice({amount: price, currency})}
                </div>
              </div>
            })
          }
        </div>
      </div>
      {this.renderPriceBreakdownSummaryRow(formatPrice({amount, currency, allowZero: true}))}
      <span className='trip-summary-price-breakdown__taxes'>All taxes and fees are included.</span>
    </div>
  }

  renderPriceBreakdownSummaryRow (amount) {
    return amount ? <div class="trip-summary-price-breakdown__total-container">
      <h4 class="trip-summary-price-breakdown__total-title">Total Paid</h4>
      <div class="trip-summary-price-breakdown__total-price-container">
        <div class="trip-summary-price-breakdown__total-price-row">
          <div class="trip-summary-price-breakdown__total-price-details"></div>
          <div class="trip-summary-price-breakdown__total-price-amount">{amount}</div>
        </div>
      </div>
    </div> : undefined
  }
}
